<template>
    <div class="field is-horizontal">
        <div class="field-label is-normal">
            <label class="label">Country</label>
        </div>
        <div class="field-body">
            <div class="field">
                <div class="control has-icons-left">
                    <div class="select is-fullwidth" v-bind:class="{ 'is-danger': errors.country }">
                        <select v-model="country">
                            <option value="" hidden disabled>Select Country</option>
                            <option v-for="country in countries">{{ country.name }}</option>
                        </select>
                    </div>
                    <span class="icon is-left">
                        <i class="fas fa-globe"></i>
                    </span>
                    <p v-if="errors.country" class="help is-danger">{{ errors.country[0] }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    export default {
        data() {
            return {
                countries: []
            }
        },
        computed: {
            country: {
                get() {
                    return this.$store.getters.getNewPricePlan.country
                },
                set(value) {
                    this.$store.dispatch('setNewPricePlanFieldValue', {field: 'country', value: value})
                }
            },
            errors() {
                return this.$store.getters.getNewPricePlanErrors
            }
        },
        created(){
            axios.get('https://restcountries.com/v3.1/all?fields=name')
                .then((response) => {
                    this.countries = response.data
                })
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/PricePlans/NewPlan/Inputs/CountrySelect.vue